import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';

const faqs = [
  {
    question: 'What types of foodstuff can I export after this masterclass?',
    answer: "The masterclass covers a wide range of foodstuffs including crops, staples, local delicacies, proteins, vegetables, and processed foods. You'll learn the specific requirements and best practices for each category."
  },
  {
    question: 'Do I need prior export experience to join?',
    answer: 'No prior export experience is required. The masterclass is designed to take you from basics to advanced concepts, making it suitable for both beginners and those with some experience.'
  },
  {
    question: 'How is the masterclass delivered?',
    answer: "The masterclass combines virtual live sessions with mentorship sessions. You'll have access to online learning materials, live instructor-led sessions, and hands-on exercises."
  },
  {
    question: 'What certifications will I receive?',
    answer: "Upon completion, you'll receive a NEPC-approved certificate. This certification is recognized by international trade organizations and buyers."
  },
  {
    question: 'Is there post-program support?',
    answer: 'Yes, graduates receive 3 months of post-program support, including mentorship, access to our alumni network, and ongoing business development resources.'
  },
  {
    question: 'What are the payment options available?',
    answer: 'We offer flexible payment options including full payment and installment plans (T & C Apply). Corporate sponsorship is also available for organizations.'
  },
  {
    question: 'Will I get trained on how to source for buyers?',
    answer: "Yes, the program includes sessions that'll train you how to source for international buyers, and how to keep them."
  },
  {
    question: 'What is the class size?',
    answer: 'To ensure quality interaction and personalized attention, we limit each cohort to 30 participants.'
  }
];

const FEMFAQs = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-gray-900 sm:text-4xl"
          >
            Frequently Asked Questions
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-xl text-gray-600"
          >
            Everything you need to know about the Foodstuff Export Masterclass
          </motion.p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-4 text-left bg-white hover:bg-gray-50"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-lg font-medium text-gray-900">
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <Minus className="h-5 w-5 text-green-600" />
                ) : (
                  <Plus className="h-5 w-5 text-green-600" />
                )}
              </button>
              <motion.div
                initial={{ height: 0 }}
                animate={{ height: openIndex === index ? 'auto' : 0 }}
                transition={{ duration: 0.3 }}
                className="overflow-hidden"
              >
                <div className="px-6 py-4 bg-gray-50">
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 text-center"
        >
          <p className="text-gray-600 mb-4">
            Still have questions? We're here to help!
          </p>
          <a
            href="mailto:info@lsem.org.ng"
            className="text-green-600 hover:text-green-700 font-medium"
          >
            Contact our support team
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FEMFAQs;